import { useSyncExternalStore } from 'react';
import { workspaceName } from '@/lib/desktop-shell/conversation-worktree';
import type { SyncedWorkspace } from '@/lib/desktop-shell/store';
import { useOptionalDesktopShellStoreApi } from '@/lib/desktop-shell/store-context';

const NO_WORKSPACES: readonly SyncedWorkspace[] = [];
const NO_SUBSCRIPTION = () => () => undefined;

/**
 * The name of a folder's repository as the server keeps it (`workspaceName`): what the header,
 * Summary, files, terminals and search call it. Outside a desktop shell, the folder's own name.
 */
export function useWorkspaceName(root: string | null): string | null {
  const store = useOptionalDesktopShellStoreApi();
  const workspaces = useSyncExternalStore(
    store?.subscribe ?? NO_SUBSCRIPTION,
    () => store?.getState().syncedWorkspaces ?? NO_WORKSPACES,
    () => store?.getState().syncedWorkspaces ?? NO_WORKSPACES,
  );
  return root === null ? null : workspaceName(workspaces, root);
}
